(() => {
  const root = document.documentElement;

  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      root.classList.toggle('menu-open', !open);
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const scope = select.closest('[data-product-section]');
    const variantsNode = scope?.querySelector('[data-product-variants]');
    if (!scope || !variantsNode) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch {
      return;
    }

    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;
      const formId = select.getAttribute('data-product-form');
      const form = document.getElementById(formId);
      const input = form?.querySelector('input[name="id"]');
      const button = form?.querySelector('[name="add"]');
      const price = scope.querySelector('[data-product-price]');
      const status = scope.querySelector('[data-product-status]');
      if (input) input.value = variant.id;
      if (price) price.textContent = Shopify.formatMoney(variant.price);
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? button.dataset.availableText : button.dataset.soldText;
      }
      if (status) status.textContent = variant.available ? '' : button?.dataset.soldText || 'Sold';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });

  document.querySelectorAll('[data-quantity-input]').forEach((input) => {
    input.addEventListener('change', () => {
      const min = Number(input.min || 1);
      const max = Number(input.max || 1);
      const value = Number(input.value || min);
      input.value = String(Math.min(max, Math.max(min, value)));
    });
  });
})();
